module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_FreeHostedGallery":{"template":[{"value":"Layout_Home","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107002},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"pageContainer":[{"value":"#container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"templateOptions.hideLeftBack":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"templateOptions.hideRightBack":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"templateOptions.hideMainMenu":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.slider.widget":[{"value":"HeaderSwipeSlider","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.slider.container":[{"value":".header-slider-wrapper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.slider.imagesPaths":[{"value":function () {
var names = [
'header.png',
'slide-image-2.jpg',
'slide-image-3.jpg',
'slide-image-4.jpg'
];
if (fox._isNewfe) {
return names.map(function (name) {
return require('../../images/' + name);
});
}
return names.map(function (name) {
return [fox.getEnv('design.url'), 'images', name].join('/');
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.footer.widget":[{"value":"Site_Footer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.footer.container":[{"value":".footer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.Layout_FreeHostedGallery","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/layout/freeHostedGallery.js
// module id = 945
// module chunks = 4